import React from 'react';

const ProductionTracking = () => {
  return (
    <div className="production-tracking">
      <div className="page-header">
        <h2>Üretim Takibi</h2>
        <p>Üretim süreçlerini takip edin</p>
      </div>
      <div className="placeholder-content">
        <h3>🚧 Geliştirme Aşamasında</h3>
        <p>Bu modül yakında eklenecektir.</p>
      </div>
    </div>
  );
};

export default ProductionTracking; 